<span class="forwardedIcon cng-ico_transfert"></span>
<p class="forwardedFrom" [title]="csr">
  <span *ngIf="bot" class="cng-ico_chatbot transfer-from-chatbot"></span>
  {{ csr }}
</p>

<div class="actions_container" *ngIf="attachments || comment">
  <mat-menu #attachmentsMenu="matMenu" xPosition="after">
    <a mat-menu-item *ngFor="let attachment of attachments" [title]="attachment.title" [href]="attachment.source">{{ attachment.title }}</a>
  </mat-menu>
  <span
    *ngIf="attachments && attachments.length > 0"
    [matMenuTriggerFor]="attachmentsMenu"
    title="{{ 'commons:attachment.display' | translate }}"
    class="action attach_action cng-ico_attach"
    >{{ attachments.length }}</span
  >
  <span *ngIf="comment" [cngTooltip]="tooltipContentRef" placement="right" class="action comment_action cng-ico_note"></span>
</div>

<ng-template #tooltipContentRef>
  {{ comment }}
</ng-template>
